import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { ContactBus } from './ContactBus';

export class PersonContactBus extends BaseBus
{
    constructor(data: PersonContactBus) {
    super(data);
  }
 person: ContactBus;
 manager: ContactBus;
}
